export default {
    namespaced: true,
    state: {
        name: null,
        sex: null
    },
    getters: {
        getName: state => state.name,
        getSex: state => state.sex
    },
    mutations: {
        setName(state, name) {
            state.name = name;
        },
        setSex(state, sex) {
            state.sex = sex;
        }
    },
    actions: {

    },
}
